/* ============================================================
   EXON product island (Track A2)
   Ported from mockups/src/pages/Product.tsx BuyBox + BuyBar + Gallery.
   Vanilla, no framework. Subscribes to window.EXON (exon-store.js):
     add-to-cart  → EXON.cart.add({ id, quantity:1 })  (emits exon:cart[:added])
     buy-now      → add silently → popup (intent checkout) → /checkout
   Emits 'exon:variant' { price, compareAt } so the mobile buy bar tracks
   the selected variant. Every DOM lookup is guarded — blocks the section
   renders are all optional.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-island]');
  if (!root) return;

  /* recently-viewed: push this product gid to the placements ring buffer
     (first-party, functional) so home/hub placements can personalize. */
  try {
    var rvPid = root.getAttribute('data-product-id');
    if (rvPid && window.__exonRV) window.__exonRV.push('gid://shopify/Product/' + rvPid);
  } catch (e) { /* ignore */ }

  /* ---------------- data ---------------- */
  function readJSON(sel, fallback) {
    var el = document.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var variants = readJSON('[data-product-json]', []);
  var meta = readJSON('[data-variant-meta]', {});
  if (!Array.isArray(variants)) variants = [];

  var authorized = root.getAttribute('data-authorized') === 'true';
  var isPreorder = root.getAttribute('data-preorder') === 'true';
  var vendorKey = root.getAttribute('data-vendor-key') || 'exon';
  var cashbackPct = parseFloat(root.getAttribute('data-cashback')) || 0;
  var moneyFormat = (root.getAttribute('data-money-format') || '₪{{amount_no_decimals}}')
    .replace(/<[^>]+>/g, ''); /* shop money_format can embed HTML spans */
  var locale = root.getAttribute('data-locale') || 'he';

  /* ---------------- money ---------------- */
  /* Mirror Shopify's money filter closely enough for live re-rendering.
     Prices in variant JSON are integer cents (agorot). */
  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    function withCommas(num, decimals) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return decimals ? parts.join('.') : parts[0];
    }
    var out = moneyFormat;
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas(n, 0));
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas(n, 2));
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas(Math.round(n), 0));
    out = out.replace(/\{\{\s*amount\s*\}\}/g, withCommas(n, 2));
    /* if the format string had no recognizable placeholder, fall back */
    if (out === moneyFormat) out = '₪' + withCommas(Math.round(n), 0);
    /* whole shekels never show trailing .00 (mockup: ₪79, not ₪79.00) */
    out = out.replace(/\.00(?!\d)/g, '');
    return out;
  }

  /* ---------------- current selection state ---------------- */
  var current = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;

  /* ---------------- helpers ---------------- */
  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function variantMeta(id) { return meta[String(id)] || {}; }

  /* ---------------- price / cashback / delivery paint ---------------- */
  var bbWas = q('[data-bb-was]');
  var bbNow = q('[data-bb-now]');
  var bbPct = q('[data-bb-pct]');
  var bbPctVal = q('[data-bb-pct-val]');
  var cashbackLine = q('[data-cashback-line]');
  var cashbackAmount = q('[data-cashback-amount]');

  function paintPrice() {
    if (!current) return;
    var price = current.price;
    var compare = current.compare_at_price || 0;
    if (bbNow) bbNow.textContent = formatMoney(price);
    if (bbWas) {
      if (compare > price) { bbWas.textContent = formatMoney(compare); bbWas.hidden = false; }
      else { bbWas.hidden = true; }
    }
    var pct = 0;
    if (compare > price && compare > 0) pct = Math.round((1 - price / compare) * 100);
    if (bbPct) {
      if (pct > 0) { bbPct.hidden = false; if (bbPctVal) bbPctVal.textContent = pct; }
      else { bbPct.hidden = true; }
    }
    /* the line's own rate wins: a campaign can raise it for this product
       (main-product.liquid campaign cashback); pack-row chips use packChip() */
    var linePct = cashbackLine ? parseFloat(cashbackLine.getAttribute('data-cashback-pct')) : NaN;
    if (!(linePct > 0)) linePct = cashbackPct;
    if (cashbackAmount && linePct > 0) {
      cashbackAmount.textContent = Math.round(price * linePct / 100 / 100);
    }
    /* mobile buy bar */
    var barPrice = q('[data-buybar-price]');
    var barWas = q('[data-buybar-was]');
    if (barPrice) barPrice.textContent = formatMoney(price);
    if (barWas) {
      if (compare > price) { barWas.textContent = formatMoney(compare); barWas.hidden = false; }
      else { barWas.hidden = true; }
    }
    /* broadcast for any other island (buy bar already handled above) */
    if (window.EXON && window.EXON.bus) {
      window.EXON.bus.emit('exon:variant', { price: price, compareAt: compare, variantId: current.id });
    }
  }

  /* ---------------- delivery label (owner rule) ---------------- */
  var dlLabel = q('[data-dl-label]');
  /* the variant's custom.delivery_method DATA values (matched, never shown) */
  var DM = { key: 'קוד דיגיטלי', account: 'חשבון דיגיטלי', auto: 'התקנה אוטומטית על החשבון' };
  /* display labels (owner 2026-09-26, EXO-3596): no "auto-install" label exists —
     auto renders as one-click on the account; account as one-click on a dedicated account */
  var DL_HE = {
    key: 'קוד דיגיטלי',
    account: 'הפעלה בקליק בחשבון ייעודי',
    click: 'הפעלה בקליק על החשבון'
  };
  var DL_EN = {
    key: 'Digital code', account: 'One-click activation on a dedicated account',
    click: 'One-click activation on your account'
  };
  function deliveryKind(vm) {
    var m = vm.delivery;
    if (m === DM.account) return 'account';
    if (m === DM.auto) return 'auto';
    if (m === DM.key) return 'key';
    /* vendor fallback mirrors the mockup DELIVERY_BY_VENDOR */
    if (vendorKey === 'playstation' || vendorKey === 'steam') return 'account';
    if (vendorKey === 'xbox') return 'auto';
    return 'key';
  }
  function paintDelivery() {
    if (!dlLabel || !current) return;
    var vm = variantMeta(current.id);
    var kind = deliveryKind(vm);
    /* mirrors the Liquid gate: auto → one-click always; key → one-click for an
       authorized vendor, except a pre-order key (ships Day One) */
    var oneClick = kind === 'auto' || (kind === 'key' && authorized && !isPreorder);
    var dict = locale === 'en' ? DL_EN : DL_HE;
    dlLabel.textContent = oneClick ? dict.click : dict[kind];
  }

  /* ---------------- tier rows: per-month / points / $ math ----------------
     KIND is set server-side on [data-vr-list] (subscription|currency|giftcard|
     license). The months/points/$ figure comes from the variant metafield when
     present, otherwise it's PARSED from the variant's option value so the math
     works on live products that carry no metafields:
       subscription: "12 + 1 חודשים"→13, "3 חודשים"→3, "חודש אחד"→1
       currency:     "1,050 נקודות"/"2800"→1050/2800  (commas stripped)
       giftcard:     "$50"→50
     Best-rate (gold badge): subscription = lowest ₪/mo, currency = highest
     points/₪, giftcard = lowest ₪/$. License rows carry no math and no auto
     best-rate (popular flag only). */
  function parseMonths(s) {
    s = String(s || '');
    var nums = s.match(/\d+/g);
    if (nums) {
      var sum = 0;
      nums.forEach(function (n) { sum += parseInt(n, 10); });
      if (sum > 0) return sum;
    }
    if (/חודש|month/i.test(s)) return 1;
    return null;
  }
  function parsePoints(s) {
    var m = String(s || '').replace(/[,٬\s]/g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }
  function parseUsd(s) {
    /* only a real $ denomination yields a ₪-per-$ rate; ₪-denominated gift
       cards ("20₪", "₪50.00") have no $ figure and get plain amount rows. */
    s = String(s || '');
    var m = s.match(/\$\s*([\d.]+)/) || s.match(/([\d.]+)\s*\$/);
    return m ? parseFloat(m[1]) : null;
  }
  function variantValue(v) {
    /* read the EFFECTIVE axis (server marks it on [data-vr-list] data-vr-axis);
       a degenerate single-valued axis (e.g. Game Pass delivery-method option0)
       means the term/points/$ live on option2, not option1. */
    if (!v) return '';
    var list = q('[data-vr-list]');
    var ax = list ? (parseInt(list.getAttribute('data-vr-axis') || '0', 10) || 0) : 0;
    if (v.options && v.options[ax] != null) return v.options[ax];
    return (v.option1 != null ? v.option1 : v.title) || '';
  }
  function tierFigure(v, kind) {
    var vm = variantMeta(v.id);
    if (kind === 'subscription') return vm.months || parseMonths(variantValue(v));
    if (kind === 'currency') return vm.points || parsePoints(variantValue(v));
    if (kind === 'giftcard') return vm.usd || parseUsd(variantValue(v));
    return null;
  }

  function paintTierMath() {
    var list = q('[data-vr-list]');
    var rows = qa('[data-vr-row]');
    if (!list || !rows.length) return;
    var kind = list.getAttribute('data-vr-kind') || '';

    /* best-rate id per kind */
    var live = variants.filter(function (v) { return v.available; });
    var bestId = null;
    if (kind === 'currency') {
      bestId = live.filter(function (v) { return tierFigure(v, kind); })
        .sort(function (a, b) {
          return (tierFigure(b, kind) / b.price) - (tierFigure(a, kind) / a.price);
        })[0];
    } else if (kind === 'giftcard') {
      bestId = live.filter(function (v) { return tierFigure(v, kind); })
        .sort(function (a, b) {
          return (a.price / tierFigure(a, kind)) - (b.price / tierFigure(b, kind));
        })[0];
    } else if (kind === 'subscription') {
      bestId = live.filter(function (v) { return tierFigure(v, kind); })
        .sort(function (a, b) {
          return (a.price / tierFigure(a, kind)) - (b.price / tierFigure(b, kind));
        })[0];
    }
    bestId = bestId ? bestId.id : null;

    var permoStrings = {
      permo: locale === 'en' ? '/ month' : '/ לחודש',
      ppsh: locale === 'en' ? 'pts / ₪' : 'נק׳ / ₪',
      gc: '₪ / $1',
      best: locale === 'en' ? 'Best value' : 'הכי משתלם'
    };

    rows.forEach(function (row) {
      var id = row.getAttribute('data-variant-id');
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      var fig = tierFigure(v, kind);
      var permoEl = q('[data-vr-permo]', row);
      var popEl = q('[data-vr-pop]', row);
      if (permoEl) {
        var html = '';
        if (kind === 'subscription' && fig) {
          var pm = (v.price / 100) / fig;
          html = '₪' + (pm % 1 ? pm.toFixed(1) : pm.toFixed(0)) + '<i>' + permoStrings.permo + '</i>';
        } else if (kind === 'currency' && fig) {
          var rate = fig / (v.price / 100);
          html = rate.toFixed(1) + '<i>' + permoStrings.ppsh + '</i>';
        } else if (kind === 'giftcard' && fig) {
          var usdRate = (v.price / 100) / fig;
          html = '₪' + usdRate.toFixed(2) + '<i>' + permoStrings.gc + '</i>';
        }
        if (html) { permoEl.innerHTML = html; permoEl.hidden = false; } else { permoEl.hidden = true; }
      }
      /* best-rate badge (gold) overrides the "popular" badge on the winning row */
      if (bestId && String(id) === String(bestId) && v.available) {
        if (!popEl) {
          popEl = document.createElement('span');
          popEl.setAttribute('data-vr-pop', '');
          row.appendChild(popEl);
        }
        popEl.className = 'vr-pop rate';
        popEl.textContent = permoStrings.best;
      }
    });
  }

  /* ---------------- tier row selection ---------------- */
  function selectVariant(v) {
    if (!v || !v.available) return;
    current = v;
    qa('[data-vr-row]').forEach(function (row) {
      var on = String(row.getAttribute('data-variant-id')) === String(v.id);
      row.classList.toggle('on', on);
      row.setAttribute('aria-checked', on ? 'true' : 'false');
      var radio = q('.vr-radio', row);
      if (radio) radio.classList.toggle('on', on);
    });
    paintPrice();
    paintDelivery();
  }

  qa('[data-vr-row]').forEach(function (row) {
    row.addEventListener('click', function () {
      if (row.disabled) return;
      var id = row.getAttribute('data-variant-id');
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      selectVariant(v);
    });
  });

  /* ---------------- multi-axis option chips ---------------- */
  var optionGroups = qa('[data-opt-group]');
  if (optionGroups.length) {
    /* current selection per axis (index → value) */
    var selected = {};
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-opt-index'), 10);
      var on = q('.opt-chip[aria-pressed="true"]', group) || q('.opt-chip', group);
      if (on) selected[idx] = on.getAttribute('data-opt-value');
    });

    function findVariant(sel) {
      return variants.filter(function (v) {
        var opts = v.options || [];
        return Object.keys(sel).every(function (i) { return opts[i] === sel[i]; });
      })[0];
    }

    function paintDeltas() {
      var baseVariant = findVariant(selected);
      var basePrice = baseVariant ? baseVariant.price : (current ? current.price : 0);
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-opt-index'), 10);
        qa('.opt-chip', group).forEach(function (chip) {
          var val = chip.getAttribute('data-opt-value');
          /* hypothetical selection swapping just this axis */
          var trial = {};
          Object.keys(selected).forEach(function (k) { trial[k] = selected[k]; });
          trial[idx] = val;
          var tv = findVariant(trial);
          var deltaEl = q('[data-opt-delta]', chip);
          /* the option dropdown mirrors these (EXO-3596 #3): trial price + state */
          chip.setAttribute('data-trial-price', tv ? tv.price : '');
          chip.setAttribute('data-trial-was', tv && tv.compare_at_price > tv.price ? tv.compare_at_price : '');
          chip.setAttribute('data-trial-state', !tv ? 'none' : (tv.available ? 'ok' : 'out'));
          /* unavailable combo → strike */
          chip.classList.toggle('off', !tv || !tv.available);
          if (!tv || !tv.available) { chip.setAttribute('disabled', ''); }
          else { chip.removeAttribute('disabled'); }
          if (deltaEl) {
            if (tv && tv.price !== basePrice) {
              var d = (tv.price - basePrice) / 100;
              deltaEl.textContent = (d > 0 ? '+₪' : '−₪') + Math.abs(d);
              deltaEl.className = 'opt-delta ltr ' + (d > 0 ? 'plus' : 'minus');
              deltaEl.hidden = false;
            } else {
              deltaEl.hidden = true;
            }
          }
        });
      });
    }

    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-opt-index'), 10);
      qa('.opt-chip', group).forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.classList.contains('off')) return;
          selected[idx] = chip.getAttribute('data-opt-value');
          qa('.opt-chip', group).forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('on', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var v = findVariant(selected);
          if (v) { current = v; paintPrice(); paintDelivery(); }
          paintDeltas();
        });
      });
    });
    paintDeltas();
  }

  /* ---------------- edition + option dropdowns (EXO-3596 #3) ----------------
     Button + listbox (select-only pattern): Enter / Space / ↓ / ↑ open, the
     arrows move over enabled options (disabled ones are skipped), Home / End,
     type-ahead by first letter, Enter / Space pick, Esc closes and returns
     focus, Tab closes (desktop). ≤640px the same panel is a bottom sheet
     (moved to <body>, since the glass buy box's backdrop-filter would contain
     a fixed child) with a backdrop, a focus trap and scroll lock.
     kind=edition  options are real links: picking navigates to that edition.
     kind=option   mirrors the hidden chip group of its axis and picks through
                   it, so the variant machinery above stays the single source. */
  (function () {
    var dds = qa('[data-ed-dd]');
    if (!dds.length) return;
    var phoneMQ = window.matchMedia ? window.matchMedia('(max-width: 640px)') : null;
    function isPhone() { return !!(phoneMQ && phoneMQ.matches); }
    var DD_T = locale === 'en'
      ? { out: 'Sold out', none: 'Unavailable' }
      : { out: 'אזל', none: 'לא זמין' };
    var openDD = null;

    function setup(dd) {
      var btn = q('.ed-dd-btn', dd);
      var panel = q('[data-dd-panel]', dd);
      if (!btn || !panel) return;
      var list = q('[role="listbox"]', panel);
      var kind = dd.getAttribute('data-dd-kind');
      var back = document.createElement('div');
      back.className = 'ed-sheet-back';
      back.setAttribute('data-dd-back', '');
      back.hidden = true;
      var sheetTitle = q('.ed-sheet-head h3', panel);
      if (sheetTitle && !sheetTitle.id) sheetTitle.id = (btn.id || 'dd') + '-sh';
      var opts = function () { return qa('[role="option"]', list); };
      var enabled = function () { return opts().filter(function (o) { return o.getAttribute('aria-disabled') !== 'true'; }); };
      var state = { sheet: false };
      var group = null;
      if (kind === 'option') group = q('[data-opt-group][data-opt-index="' + dd.getAttribute('data-dd-axis') + '"]');

      /* option kind: read the hidden chip group into the rows + the trigger */
      function sync() {
        if (!group) return;
        var chips = qa('.opt-chip', group);
        var curPrice = current ? current.price : 0;
        opts().forEach(function (o) {
          var chip = chips[parseInt(o.getAttribute('data-dd-i'), 10)];
          if (!chip) return;
          var on = chip.getAttribute('aria-pressed') === 'true';
          var st = chip.getAttribute('data-trial-state') || 'ok';
          var price = parseInt(chip.getAttribute('data-trial-price'), 10);
          var was = parseInt(chip.getAttribute('data-trial-was'), 10);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          if (st !== 'ok' && !on) o.setAttribute('aria-disabled', 'true'); else o.removeAttribute('aria-disabled');
          var now = q('[data-dd-now]', o), wasEl = q('[data-dd-was]', o);
          if (now) now.textContent = isFinite(price) ? formatMoney(price) : '';
          if (wasEl) { if (isFinite(was) && was > 0) { wasEl.textContent = formatMoney(was); wasEl.hidden = false; } else wasEl.hidden = true; }
          var tick = q('[data-dd-tick]', o), out = q('[data-dd-out]', o), delta = q('[data-dd-delta]', o);
          if (tick) tick.hidden = !on;
          if (out) { out.hidden = on || st === 'ok'; out.textContent = st === 'none' ? DD_T.none : DD_T.out; }
          if (delta) {
            var d = isFinite(price) ? price - curPrice : 0;
            if (!on && st === 'ok' && d !== 0) {
              delta.textContent = (d > 0 ? '+' : '−') + formatMoney(Math.abs(d));
              delta.className = 'opt-delta ltr ' + (d > 0 ? 'plus' : 'minus');
              delta.hidden = false;
            } else delta.hidden = true;
          }
          if (on) { var cur = q('[data-dd-cur]', btn); if (cur) cur.textContent = o.getAttribute('data-name'); }
        });
      }
      dd.__ddSync = sync;

      function focusOpt(o) { if (o) o.focus({ preventScroll: false }); }
      function place(toSheet) {
        state.sheet = toSheet;
        panel.classList.toggle('is-sheet', toSheet);
        if (toSheet) {
          document.body.appendChild(back);
          document.body.appendChild(panel);
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          if (sheetTitle) panel.setAttribute('aria-labelledby', sheetTitle.id);
        } else {
          if (panel.parentNode !== dd) dd.appendChild(panel);
          if (back.parentNode) back.parentNode.removeChild(back);
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
          panel.removeAttribute('aria-labelledby');
        }
      }
      function open(target) {
        if (openDD && openDD !== api) openDD.close(false);
        sync();
        place(isPhone());
        panel.hidden = false;
        back.hidden = !state.sheet;
        if (state.sheet) document.documentElement.classList.add('ed-sheet-lock');
        btn.setAttribute('aria-expanded', 'true');
        dd.classList.add('is-open');
        openDD = api;
        var list2 = enabled();
        var t = target === 'last' ? list2[list2.length - 1]
          : (q('[aria-selected="true"]', list) || list2[0]);
        focusOpt(t);
      }
      function close(refocus) {
        if (panel.hidden) return;
        panel.hidden = true;
        back.hidden = true;
        document.documentElement.classList.remove('ed-sheet-lock');
        btn.setAttribute('aria-expanded', 'false');
        dd.classList.remove('is-open');
        if (state.sheet) place(false);
        if (openDD === api) openDD = null;
        if (refocus) btn.focus({ preventScroll: true });
      }
      function pick(o) {
        if (!o || o.getAttribute('aria-disabled') === 'true') return;
        if (kind === 'edition') {
          var href = o.getAttribute('href');
          close(!href);
          if (href) window.location.href = href;
          return;
        }
        var chip = group ? qa('.opt-chip', group)[parseInt(o.getAttribute('data-dd-i'), 10)] : null;
        /* close first: the chip's click bubbles to the document, where an
           outside-click would otherwise close without returning focus */
        close(true);
        if (chip && chip.getAttribute('aria-pressed') !== 'true') chip.click();
        sync();
      }
      var api = { close: close, sync: sync, panel: panel, dd: dd };

      btn.addEventListener('click', function () { panel.hidden ? open() : close(false); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(e.key === 'ArrowUp' ? 'last' : null); }
      });
      list.addEventListener('click', function (e) {
        var o = e.target.closest('[role="option"]');
        if (!o) return;
        if (o.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
        if (kind === 'edition' && o.getAttribute('href')) { close(false); return; } /* native navigation */
        e.preventDefault();
        pick(o);
      });
      back.addEventListener('click', function () { close(true); });
      qa('[data-dd-close]', panel).forEach(function (x) {
        x.addEventListener('click', function (e) {
          var isLink = x.tagName === 'A' && x.getAttribute('href');
          close(!isLink);
          if (isLink && state.sheet) { /* the panel already closed; let the anchor scroll */ }
        });
      });
      panel.addEventListener('keydown', function (e) {
        var list2 = enabled();
        var i = list2.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); focusOpt(list2[i < 0 ? 0 : Math.min(list2.length - 1, i + 1)]); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); focusOpt(list2[i < 0 ? 0 : Math.max(0, i - 1)]); }
        else if (e.key === 'Home') { e.preventDefault(); focusOpt(list2[0]); }
        else if (e.key === 'End') { e.preventDefault(); focusOpt(list2[list2.length - 1]); }
        else if (e.key === 'Escape') { e.preventDefault(); close(true); }
        else if (e.key === 'Enter' || e.key === ' ') {
          var a = document.activeElement;
          if (a && a.getAttribute('role') === 'option') { e.preventDefault(); pick(a); }
        } else if (e.key === 'Tab') {
          if (!state.sheet) { close(false); return; }
          /* sheet: keep focus inside (close button, options, footer link) */
          var f = qa('button, a[href], [role="option"]:not([aria-disabled="true"])', panel)
            .filter(function (el) { return el.offsetParent !== null; });
          if (!f.length) return;
          var k = f.indexOf(document.activeElement);
          e.preventDefault();
          f[(k + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
        } else if (e.key.length === 1 && /\S/.test(e.key)) {
          var ch = e.key.toLowerCase();
          var from = i + 1;
          var ordered = list2.slice(from).concat(list2.slice(0, from));
          var hit = ordered.filter(function (o) { return (o.getAttribute('data-name') || '').trim().toLowerCase().indexOf(ch) === 0; })[0];
          if (hit) focusOpt(hit);
        }
      });
      document.addEventListener('click', function (e) {
        if (panel.hidden || state.sheet) return;
        if (!dd.contains(e.target)) close(false);
      });
      /* crossing the 640px line while open: re-seat as popover or sheet */
      if (phoneMQ && phoneMQ.addEventListener) {
        phoneMQ.addEventListener('change', function () { if (!panel.hidden) { close(false); } });
      }
      sync();
      return api;
    }

    var apis = dds.map(setup).filter(Boolean);
    /* a pick on one axis changes the others' deltas and availability */
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.opt-chip')) apis.forEach(function (a) { a.sync(); });
    });
  })();

  /* ---------------- sale countdown ---------------- */
  var countdown = q('[data-countdown]');
  if (countdown) {
    var endsAt = parseInt(countdown.getAttribute('data-ends'), 10) * 1000;
    var valEl = q('[data-countdown-val]', countdown);
    function tick() {
      var diff = endsAt - Date.now();
      if (isNaN(endsAt) || diff <= 0) { countdown.hidden = true; return; }
      countdown.hidden = false;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      if (valEl) valEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- gallery ---------------- */
  var gallery = q('[data-gallery]');
  if (gallery) {
    var mainImg = q('[data-gal-main-img]', gallery);
    var mainVideo = q('[data-gal-main-video]', gallery);
    var caption = q('[data-gal-caption]', gallery);
    var thumbs = qa('[data-gal-thumb]', gallery);
    var mainWrap = q('.gal-main', gallery);
    var ytFacade = q('[data-gal-yt-facade]', gallery);
    var ytFrame = null;

    /* YouTube trailer: facade image until a real gesture, then a nocookie
       embed — no third-party payload on load. Leaving the trailer clears the
       iframe src so audio stops. */
    function showYt(id) {
      if (mainImg) mainImg.hidden = true;
      if (mainVideo) { mainVideo.hidden = true; mainVideo.pause && mainVideo.pause(); }
      if (ytFacade) ytFacade.hidden = true;
      if (!ytFrame) {
        ytFrame = document.createElement('iframe');
        ytFrame.setAttribute('data-gal-yt', '');
        ytFrame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        ytFrame.setAttribute('allowfullscreen', '');
        ytFrame.setAttribute('title', 'Trailer');
        if (mainWrap) mainWrap.insertBefore(ytFrame, caption || null);
      }
      ytFrame.hidden = false;
      ytFrame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
        '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
      if (caption) caption.textContent = 'TRAILER';
    }
    function hideYt() {
      if (ytFrame) { ytFrame.hidden = true; ytFrame.src = ''; }
      if (ytFacade) ytFacade.hidden = true;
    }

    function showMedia(thumb, index) {
      var type = thumb.getAttribute('data-type');
      var src = thumb.getAttribute('data-src');
      thumbs.forEach(function (t) { t.classList.toggle('on', t === thumb); });
      if (type === 'yt') {
        showYt(src);
      } else if (type === 'video') {
        hideYt();
        if (mainImg) mainImg.hidden = true;
        if (!mainVideo) {
          mainVideo = document.createElement('video');
          mainVideo.setAttribute('data-gal-main-video', '');
          mainVideo.autoplay = true; mainVideo.muted = true; mainVideo.loop = true; mainVideo.playsInline = true;
          if (mainWrap) mainWrap.insertBefore(mainVideo, caption || null);
        }
        mainVideo.hidden = false; mainVideo.src = src;
        mainVideo.play && mainVideo.play().catch(function () {});
      } else {
        hideYt();
        if (mainVideo) { mainVideo.hidden = true; mainVideo.pause && mainVideo.pause(); }
        if (!mainImg) {
          mainImg = document.createElement('img');
          mainImg.setAttribute('data-gal-main-img', '');
          if (mainWrap) mainWrap.insertBefore(mainImg, caption || null);
        }
        mainImg.hidden = false; mainImg.src = src;
        if (caption) caption.textContent = (index + 1) + ' / ' + thumbs.length;
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showMedia(thumb, i); });
    });
    if (ytFacade) {
      ytFacade.addEventListener('click', function () {
        showYt(ytFacade.getAttribute('data-yt'));
      });
      if (caption) caption.textContent = 'TRAILER';
    }
    /* seed caption for the first image thumb */
    thumbs.forEach(function (t, i) {
      if (t.classList.contains('on') && t.getAttribute('data-type') === 'img' && caption) {
        caption.textContent = (i + 1) + ' / ' + thumbs.length;
      }
    });
  }

  /* ---------------- description expander ---------------- */
  var expand = q('[data-expand]');
  if (expand) {
    var body = q('[data-expand-body]', expand);
    var btn = q('[data-expand-btn]', expand);
    var plus = q('[data-xp-plus]', expand);
    var minus = q('[data-xp-minus]', expand);
    var collapsedHeight = body ? body.style.maxHeight : '118px';
    if (btn) {
      btn.addEventListener('click', function () {
        var open = expand.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (body) body.style.maxHeight = open ? (body.scrollHeight + 40) + 'px' : collapsedHeight;
        if (plus) plus.hidden = open;
        if (minus) minus.hidden = !open;
      });
    }
  }

  /* ---------------- related products (Section Rendering API) ----------------
     Server-render is empty on first paint (recommendations.performed is false
     for a normal request); fetch the recommendations intent and swap in the
     rendered rail. Fails quietly — the section just stays empty. */
  /* the related rail lives in its own section (main-product-related), OUTSIDE
     the product island, so look it up on the whole document. */
  var recBlock = document.querySelector('[data-recommendations]');
  if (recBlock) {
    var recUrl = recBlock.getAttribute('data-url');
    var rail = recBlock.querySelector('[data-rail]');
    if (recUrl && rail && !rail.children.length) {
      fetch(recUrl)
        .then(function (res) { return res.ok ? res.text() : Promise.reject(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRail = doc.querySelector('[data-rail]');
          if (freshRail && freshRail.children.length) {
            rail.innerHTML = freshRail.innerHTML;
          } else {
            recBlock.hidden = true;
          }
        })
        .catch(function () { recBlock.hidden = true; });
    }
  }

  /* ---------------- COMPLETE THE PACKAGE (engine-driven) ----------------
     Port of mockups Product.tsx PackageSection (PkGroup/PkRow) wired to the
     production family API: config from the shared #exon-upsell-cfg blob,
     POST {apiBase}/family with { shop_domain, product_gid }. The endpoint
     returns strictly same-family items already split into `extensions`
     (add-ons group) and `currencies` (currency group) — no client-side
     kind-split or upgrade filtering needed. When the API is unset, fails,
     times out or returns nothing/malformed, the sections stay [hidden]. */
  (function () {
    var secs = qa('[data-pack-sec]');
    if (!secs.length) return;

    var cfg = readJSON('#exon-upsell-cfg', {}) || {};
    var apiBase = String(cfg.proxyBase || cfg.offerApiBase || '').trim().replace(/\/+$/, '');
    if (!apiBase || cfg.enabled === false) return;

    var productId = root.getAttribute('data-product-id') || '';
    if (!productId) return;
    var productGid = 'gid://shopify/Product/' + productId;
    var routesRoot = String(cfg.routesRoot || '/').replace(/\/+$/, '') + '/';

    function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function gidToId(gid) {
      var m = String(gid || '').match(/\/(\d+)(\?|$)/);
      return m ? m[1] : '';
    }

    var BAG_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0"/></svg>';
    var addLabel = locale === 'en' ? 'Add to cart' : 'הוסיפו לסל';
    /* campaign cashback (layout/theme.liquid cbCampaign, server-gated): a
       listed product's row shows the campaign rate until the end; the chip is
       marked so cards.js returns it to the store rate at the end time. */
    var cbcCfg = null;
    try {
      var cfgEl = document.getElementById('exon-placements-cfg');
      var cfgAll = cfgEl ? JSON.parse(cfgEl.textContent) : null;
      if (cfgAll && cfgAll.cbCampaign && typeof cfgAll.cbCampaign === 'object') cbcCfg = cfgAll.cbCampaign;
    } catch (e) { cbcCfg = null; }
    /* Sukkot extension 2026-10-03: the store rate switches at
       cashbackAfter.at (layout/theme.liquid, present only while ahead);
       storePctAt(t) = the store rate at t (same rule as placements.js). */
    var cbaCfg = null;
    try {
      if (cfgAll && cfgAll.cashbackAfter && typeof cfgAll.cashbackAfter === 'object') cbaCfg = cfgAll.cashbackAfter;
    } catch (e) { cbaCfg = null; }
    function storePctAt(t) {
      var at = cbaCfg ? Number(cbaCfg.at) || 0 : 0;
      return at > 0 && t >= at ? (Number(cbaCfg.pct) || 0) : cashbackPct;
    }
    function cbLabel(p) {
      return p > 0 ? (locale === 'en' ? p + '% cashback' : p + '% קאשבק') : '';
    }
    function packChip(handle) {
      var now = Date.now();
      var store = storePctAt(now);
      var base = cbLabel(store);
      var ends = cbcCfg ? Number(cbcCfg.endsAt) || 0 : 0;
      var pct = cbcCfg ? Number(cbcCfg.pct) || 0 : 0;
      var on = cbcCfg && pct > store && ends > now && Array.isArray(cbcCfg.handles) &&
        cbcCfg.handles.indexOf(String(handle || '')) !== -1;
      if (on) {
        var txt = locale === 'en' ? pct + '% cashback' : pct + '% קאשבק';
        return '<span class="cb-mini" data-cbc-card data-cbc-ends="' + ends + '" data-cbc-base="' + esc(cbLabel(storePctAt(ends))) + '">' + esc(txt) + '</span>';
      }
      /* a pending store-rate switch marks the plain chip; cards.js turns it */
      var sw = cbaCfg ? Number(cbaCfg.at) || 0 : 0;
      if (base && sw > now) {
        return '<span class="cb-mini" data-cbc-card data-cbc-ends="' + sw + '" data-cbc-base="' + esc(cbLabel(Number(cbaCfg.pct) || 0)) + '">' + esc(base) + '</span>';
      }
      return base ? '<span class="cb-mini">' + esc(base) + '</span>' : '';
    }

    /* variant-row detection: the /family endpoint now returns one row per
       variant. A "meaningful" variant title is non-blank and not Shopify's
       single-variant placeholder ("Default Title" / "default"). When a product
       contributes >1 variant row, the denomination is the decision-relevant
       fact, so it takes the .pk-short line; otherwise reason_text stays. Absent
       variant_title/variant_count degrades to exactly the per-product behavior. */
    function meaningfulVariant(t) {
      var s = String(t == null ? '' : t).trim().toLowerCase();
      return !!s && s !== 'default title' && s !== 'default';
    }

    function rowHTML(o, rowsForProduct) {
      var img = String(o.image_url || o.image || '');
      if (!/^https?:\/\//i.test(img)) img = '';
      var handle = String(o.handle || '');
      var title = String(o.title || '');
      if (!title) return '';
      var priceMinor = Math.round(num(o.price != null ? o.price : o.price_amount) * 100); /* API: MAJOR units */
      var compareMinor = Math.round(num(o.compare_at || o.compareAt) * 100);
      var reason = String(o.reason || o.reason_text || '');
      var variantTitle = String(o.variant_title || o.variantTitle || '');
      var variantCount = num(o.variant_count != null ? o.variant_count : o.variantCount);
      var vId = gidToId(o.variant_gid || o.variantGid);
      /* Treat as a per-variant (denomination) row only when the product truly
         contributes >1 row to this section — not merely when variant_count>1.
         Pre-deploy the API reports the product's full variant_count while still
         collapsing it to one row; guarding on the actual row tally keeps that
         case on the plain per-product path (exactly today's behavior). */
      var isVariantRow = variantCount > 1 && rowsForProduct > 1 && !!vId;
      var shortText = (isVariantRow && meaningfulVariant(variantTitle)) ? variantTitle : reason;
      var html = '<div class="pk-row" data-pack-row data-handle="' + esc(handle) + '" data-variant-id="' + esc(vId) + '"' + (isVariantRow ? ' data-variant-row="1"' : '') + '>';
      html += '<span class="pk-thumb">' + (img
        ? '<img src="' + esc(img) + '" alt="" loading="lazy">'
        : '<span class="key-cover"><span class="key-bloom"></span><span class="key-brand mono ltr">EXON · DIGITAL KEY</span><span class="key-lines"></span></span>') + '</span>';
      html += '<div class="pk-info"><b>' + esc(title) + '</b>';
      if (shortText) html += '<span class="pk-short">' + esc(shortText) + '</span>';
      html += packChip(handle);
      html += '</div>';
      html += '<div class="pk-price">';
      if (compareMinor > priceMinor) html += '<s class="ltr">' + esc(formatMoney(compareMinor)) + '</s>';
      html += '<span class="pk-now"><b class="ltr">' + esc(formatMoney(priceMinor)) + '</b></span>';
      html += '</div>';
      html += '<button type="button" class="bundle-add" data-pack-add title="' + esc(addLabel) + '" aria-label="' + esc(addLabel) + '">' + BAG_SVG + '<i class="bundle-add-plus">+</i></button>';
      html += '</div>';
      return html;
    }

    function resolveVariantId(row) {
      var vid = row.getAttribute('data-variant-id');
      if (vid) return Promise.resolve(vid);
      var handle = row.getAttribute('data-handle');
      if (!handle) return Promise.resolve('');
      return fetch(routesRoot + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod || !prod.variants) return '';
          var v = prod.variants.filter(function (x) { return x.available; })[0] || prod.variants[0];
          return v ? String(v.id) : '';
        })
        .catch(function () { return ''; });
    }

    function wireGroup(sec, offers) {
      var rowsEl = q('[data-pack-rows]', sec);
      var moreWrap = q('[data-pack-more]', sec);
      var moreBtn = q('[data-pack-more-btn]', sec);
      if (!rowsEl || !offers.length) return false;
      /* tally rows per product so rowHTML can tell a genuine multi-variant
         denomination split from a single collapsed product row */
      var perProduct = {};
      offers.forEach(function (o) {
        var k = String((o && (o.product_gid || o.productGid || o.handle)) || '');
        perProduct[k] = (perProduct[k] || 0) + 1;
      });
      var html = offers.map(function (o) {
        var k = String((o && (o.product_gid || o.productGid || o.handle)) || '');
        return rowHTML(o, perProduct[k] || 1);
      }).join('');
      if (!html) return false;
      rowsEl.innerHTML = html;
      var rows = qa('[data-pack-row]', rowsEl);

      /* mockup PkGroup: show 3, round +/− reveals the rest */
      if (rows.length > 3 && moreWrap && moreBtn) {
        rows.forEach(function (r, i) { if (i >= 3) r.hidden = true; });
        moreWrap.hidden = false;
        var plus = q('[data-xp-plus]', moreBtn);
        var minus = q('[data-xp-minus]', moreBtn);
        moreBtn.addEventListener('click', function () {
          var open = moreBtn.getAttribute('aria-expanded') === 'true';
          open = !open;
          moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          rows.forEach(function (r, i) { if (i >= 3) r.hidden = !open; });
          if (plus) plus.hidden = open;
          if (minus) minus.hidden = !open;
        });
      }

      rows.forEach(function (row) {
        row.addEventListener('click', function () {
          var handle = row.getAttribute('data-handle');
          if (!handle) return;
          var url = routesRoot + 'products/' + encodeURIComponent(handle);
          /* multi-variant rows land the shopper on their chosen denomination */
          if (row.getAttribute('data-variant-row') === '1') {
            var vid = row.getAttribute('data-variant-id');
            if (vid) url += '?variant=' + encodeURIComponent(vid);
          }
          window.location = url;
        });
        var addBtn = q('[data-pack-add]', row);
        if (addBtn) {
          addBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (!window.EXON) return;
            resolveVariantId(row).then(function (vid) {
              if (!vid) return;
              var items = { id: vid, quantity: 1 };
              window.EXON.cart.add(items, { silent: true }).then(function () {
                window.EXON.bus.emit('exon:cart:added', { items: [items], intent: 'cart' });
              }).catch(function () {});
            });
          });
        }
      });
      sec.hidden = false;
      return true;
    }

    /* strip the page's own product; the engine already scopes to family */
    function clean(list) {
      return (Array.isArray(list) ? list : []).filter(function (o) {
        if (!o) return false;
        var pg = String(o.product_gid || o.productGid || '');
        return !(pg && pg === productGid);
      });
    }

    /* DLC base-game anchor (engine fallback). The /family response may include a
       base_game { title, handle, image_url, price, variant_gid, product_gid } for
       DLC anchors. Inject the SAME dlc-row markup the Liquid renders — but ONLY
       when the server didn't already render one (custom.required_product wins) and
       the [data-dlc-slot] exists. Fail-soft: no base_game / no slot / slot already
       filled / missing title+handle → nothing changes. */
    var LINK_SVG = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
    function injectBaseGame(bg) {
      if (!bg) return;
      var slot = document.querySelector('[data-dlc-slot]');
      if (!slot || slot.querySelector('.dlc-row')) return;
      var title = String(bg.title || '');
      var handle = String(bg.handle || '');
      if (!title || !handle) return;
      var img = String(bg.image_url || bg.image || '');
      if (!/^https?:\/\//i.test(img)) img = '';
      var url = routesRoot + 'products/' + encodeURIComponent(handle);
      var dict = locale === 'en'
        ? { req: 'Requires the base game', own: "Don't own it yet?", go: 'View the game' }
        : { req: 'דורש את משחק הבסיס', own: 'אין לכם אותו עדיין?', go: 'לעמוד המשחק' };
      var art = img
        ? '<img src="' + esc(img) + '" alt="" width="42" height="42" loading="lazy">'
        : '<span class="key-cover"><span class="key-bloom"></span><span class="key-brand mono ltr">EXON · DIGITAL KEY</span><span class="key-lines"></span></span>';
      var html = '<a class="dlc-row" href="' + esc(url) + '">'
        + '<span class="dlc-art">' + art + '</span>'
        + '<div><b>' + LINK_SVG + ' ' + esc(dict.req) + '</b>'
        + '<span>' + esc(title) + ' · ' + esc(dict.own) + '</span></div>'
        + '<span class="btn btn-ghost" style="height:32px;padding:0 12px;font-size:11.5px;">' + esc(dict.go) + '</span>'
        + '</a>';
      slot.innerHTML = html;
    }

    /* family request — { shop_domain, product_gid }, text/plain like upsell.js
       (CORS-simple, no preflight). Fail-soft: any error, non-2xx, ok:false or
       malformed body leaves both sections [hidden]. */
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 4500) : null;
    fetch(apiBase + '/family', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
      credentials: 'omit',
      signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({
        shop_domain: cfg.canonicalShop,
        product_gid: productGid
      })
    }).then(function (res) { return res.ok ? res.json() : null; })
      .then(function (body) {
        if (timer) clearTimeout(timer);
        if (!body || !body.ok) return;
        injectBaseGame(body.base_game || body.baseGame);
        var addons = clean(body.extensions);
        var currency = clean(body.currencies);
        secs.forEach(function (sec) {
          var kind = sec.getAttribute('data-pack-sec');
          wireGroup(sec, kind === 'currency' ? currency : addons);
        });
      })
      .catch(function () { if (timer) clearTimeout(timer); /* stays hidden */ });
  })();

  /* ---------------- sprinkles ---------------- */
  qa('[data-sprinkles]').forEach(function (field) {
    var n = parseInt(field.getAttribute('data-spr-n'), 10) || 8;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span');
      var size = (Math.random() * 2 + 1).toFixed(1);
      s.className = 'spr ' + (i % 3 === 0 ? 'spr-drift' : 'spr-fall');
      s.style.left = (Math.random() * 100).toFixed(1) + '%';
      s.style.width = size + 'px';
      s.style.height = size + 'px';
      s.style.animationDelay = (Math.random() * 2.5).toFixed(2) + 's';
      s.style.animationDuration = (Math.random() * 1.6 + 1.4).toFixed(2) + 's';
      field.appendChild(s);
    }
  });

  /* ---------------- cart actions ---------------- */
  /* owner-locked flows: add → popup → drawer; buy-now → popup → checkout.
     Both routes go THROUGH the popup — buy-now adds silently, then emits the
     added event itself with intent 'checkout' so the popup's CTA targets
     /checkout instead of the drawer. If the popup island is absent/disabled,
     fall back to a direct checkout redirect. */
  /* attribution carrier (P-BANNER B1): if a placement click stored a non-expired
     last-touch record for THIS product (placements.js → sessionStorage
     'exon_plc_attr'), stamp the add with hidden line-item properties so the order
     webhook can attribute the sale to the placement. Additive + fail-open: any
     error here must never block or alter the add-to-cart. Prefixed '_' props are
     hidden from customers. Only the main PDP form; card quick-add + upsell flows
     are intentionally out of scope for B1. */
  function plcProps() {
    try {
      var pid = root && root.getAttribute('data-product-id');
      if (!pid) return null;
      var gid = 'gid://shopify/Product/' + pid;
      var raw = sessionStorage.getItem('exon_plc_attr');
      if (!raw) return null;
      var e = (JSON.parse(raw) || {})[gid];
      if (!e || !e.t) return null;
      if (Date.now() - (e.ts || 0) > 86400000) return null; /* 24h expiry */
      return { _exon_plc_token: String(e.t), _exon_plc_product: gid };
    } catch (err) { return null; }
  }

  /* aggregation-safe: Shopify line identity includes properties, so attaching
     carrier props to a variant already in the cart would create a SECOND,
     visually identical row. Consult the drawer's cached /cart.js snapshot
     (EXON.cart.state — refreshed on load + after every mutation; only stale if
     another tab mutated the cart since, which we accept over a blocking call).
     If the snapshot hasn't landed yet (add fired before the boot /cart.js
     resolved), await the IN-FLIGHT boot refresh (EXON.cart.ready — no new
     request) bounded to 800ms, then re-read. If the cart is STILL unknown,
     attach NOTHING — an unknown cart prefers aggregation-safety over attribution.
     If the variant is already carted, mirror that line's EXISTING properties
     verbatim so the add MERGES; else attach carrier props. */
  async function attachProps(variantId) {
    var C = window.EXON && window.EXON.cart, st = null;
    try {
      st = C && C.state;
      if (!st && C && C.ready) {
        await Promise.race([C.ready, new Promise(function (r) { setTimeout(r, 800); })]);
        st = C.state;
      }
    } catch (e) { st = null; }
    if (!st) return null; /* cart unknown → aggregation-safe, no attribution */
    try {
      var lines = st.items || [];
      for (var i = 0; i < lines.length; i++) {
        if (lines[i] && String(lines[i].variant_id) === String(variantId)) {
          var ep = lines[i].properties;
          return (ep && typeof ep === 'object' && Object.keys(ep).length) ? Object.assign({}, ep) : null;
        }
      }
    } catch (e) { /* fall through to attribute */ }
    return plcProps(); /* variant not in cart → attribute normally */
  }

  async function addSelected(mode) {
    if (!current || !window.EXON) return;
    var items = { id: current.id, quantity: 1 };
    try { var props = await attachProps(current.id); if (props) items.properties = props; } catch (e) { /* fail-open */ }
    window.EXON.cart.add(items, { silent: true })
      .then(function () {
        var popupLive = document.querySelector('[data-exon-popup]');
        if (mode === 'checkout') {
          if (popupLive) {
            window.EXON.bus.emit('exon:cart:added', { items: [items], intent: 'checkout' });
          } else {
            window.location = '/checkout';
          }
        } else {
          window.EXON.bus.emit('exon:cart:added', { items: [items], intent: 'cart' });
        }
      })
      .catch(function () { /* surfaced by the cart store; keep the page usable */ });
  }

  qa('[data-buy-now], [data-buybar-buy]').forEach(function (el) {
    el.addEventListener('click', function () { addSelected('checkout'); });
  });
  qa('[data-add-cart]').forEach(function (el) {
    el.addEventListener('click', function () { addSelected('cart'); });
  });

  /* ---------------- campaign cashback clock ----------------
     The row exists only while the server says the campaign runs
     (main-product.liquid `cbc_on`; the inline guard already folded a cached
     page whose end has passed). Ticks days/hours/min/sec to data-cbc-ends;
     under 24h the days cell steps out and the sub line reads the last-day
     text; in the final hour the digits turn soft red; at zero the row swaps
     in place to the store rate and the campaign parts fold away. The amount
     keeps following paintPrice's rule (price × data-cashback-pct). */
  (function () {
    var row = q('[data-cbc-row]');
    if (!row || !cashbackLine) return;
    var ends = parseInt(row.getAttribute('data-cbc-ends'), 10);
    if (!(ends > 0)) return;
    var WEEK = 7 * 864e5;
    var cd = q('[data-cbc-cd]', row);
    var sub = q('[data-cbc-sub]', row);
    var timer = null;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function setCell(u, val) {
      var b = q('[data-cd="' + u + '"]', row);
      if (!b || b.textContent === val) return;
      b.textContent = val;
      b.classList.remove('is-tick'); void b.offsetWidth; b.classList.add('is-tick');
    }
    function swap(el, val) {
      if (!el) return;
      el.textContent = val;
      el.classList.remove('is-swap'); void el.offsetWidth; el.classList.add('is-swap');
    }
    function flip() {
      if (timer) { clearInterval(timer); timer = null; }
      if (row.hasAttribute('data-cbc-done')) return;
      row.setAttribute('data-cbc-done', '');
      var base = cashbackLine.getAttribute('data-cashback-store-pct');
      cashbackLine.setAttribute('data-cashback-pct', base);
      swap(q('[data-cashback-pct-val]', cashbackLine), base);
      if (current && cashbackAmount && parseFloat(base) > 0) {
        swap(cashbackAmount, String(Math.round(current.price * parseFloat(base) / 100 / 100)));
      }
      row.setAttribute('data-cbc-ending', '');
      setTimeout(function () {
        qa('[data-cbc]', row).forEach(function (el) { el.hidden = true; });
        row.classList.remove('is-cbc');
        row.removeAttribute('data-cbc-ending');
        row.removeAttribute('data-cbc-lastday');
        row.removeAttribute('data-cbc-urgent');
        row.removeAttribute('data-cbc-row');
        row.style.removeProperty('--cb-left');
      }, 520);
    }
    function paint() {
      var diff = ends - Date.now();
      if (diff <= 0) { flip(); return; }
      if (cd) cd.hidden = false;
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5),
          m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
      setCell('d', pad(d)); setCell('h', pad(h)); setCell('m', pad(m)); setCell('s', pad(s));
      row.toggleAttribute('data-cbc-lastday', d === 0);
      row.toggleAttribute('data-cbc-urgent', diff < 36e5);
      row.style.setProperty('--cb-left', Math.max(0, Math.min(1, diff / WEEK)).toFixed(4));
      if (sub) {
        var t = d === 0 ? sub.getAttribute('data-last') : sub.getAttribute('data-date');
        if (t && sub.textContent !== t) sub.textContent = t;
      }
    }
    paint();
    if (!row.hasAttribute('data-cbc-done')) {
      timer = setInterval(paint, 1000);
      /* a hidden tab's timers are throttled: repaint the moment it is seen */
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && !row.hasAttribute('data-cbc-done')) paint();
      });
    }
  })();

  /* ---------------- buy column height → sticky offset ----------------
     product.css pins .pd-side by its bottom when it is taller than the
     viewport; it needs the column's live height (variant swaps, fonts). */
  (function () {
    var side = document.querySelector('.pd-side');
    if (!side) return;
    function publish() { side.style.setProperty('--pd-side-h', side.offsetHeight + 'px'); }
    publish();
    if (window.ResizeObserver) new ResizeObserver(publish).observe(side);
  })();

  /* ---------------- first paint ---------------- */
  paintTierMath();
  paintPrice();
  paintDelivery();
})();
